import React, { useState } from "react";
import { StarShop } from "pages";
import { useSelector } from "react-redux";
import qs from "qs";

import { login } from "store/modules/common/loginReducer";

const StarshopContainer = ({ location }) => {
    const query = qs.parse(location.search, {
        ignoreQueryPrefix: true,
    });

    const loginInfo = useSelector((state) => state.loginReducer);
    const [type, setType] = useState(query.tab || "1");

    const myInfo = {
        userId: loginInfo.userId,
        userNm: loginInfo.mmbrName,
        contractNumber: loginInfo.contractNumber,
        customerNumber: loginInfo.customerNumber,
        mmbrSeq: loginInfo.mmbrSeq,
        authCode: loginInfo.authCode,
        pedcCd: loginInfo.pedcCd,
    };

    return (
        <>
            <StarShop myInfo={myInfo} type={type} setType={setType} />
        </>
    );
};

export default StarshopContainer;
